<script lang="ts">
	import type { PublishedCaseStudy } from "../../../../core/schema/CaseStudy.js";
	import DynamicPicture from "../Picture/DynamicPicture.svelte";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import Link from "../Link.svelte";
	import { getReferencePath } from "../../../../core/schema/paths/getReferencePath.js";
	import Content from "../Content.svelte";
	import { caseStudyCategoryNameMap } from "../../../../core/schema/names/caseStudyCategoryNameMap.js";
	import { nbspify } from "../../../../core/utils/nbspify.js";

	export let reference: PublishedCaseStudy;

	const { TENANT_LOCALE } = getGlobalSettings();
</script>

<a
	class="group flex h-[28rem] w-full max-w-[34.688rem] flex-col lg:h-[32.25rem] lg:max-w-[41.875rem]"
	href="/{getReferencePath(reference)}"
>
	<DynamicPicture
		image={reference.thumbnailImage}
		bucket="storage"
		alt=""
		width={555}
		height={370}
		imgClass="lg:max-w-[34.688rem] pr-4 object-cover h-[19rem] lg:h-[23.125rem]"
		class="relative lg:ml-auto"
	/>
	<div class="relative z-20 flex h-full flex-col lg:flex-row">
		<div class="absolute bottom-0 left-4 right-0 block lg:left-0 lg:right-auto lg:w-full lg:max-w-[34.688rem]">
			<div
				class="text-2xs bg-primary absolute right-0 top-0 ml-auto flex h-[1.375rem] w-[7.5rem] -translate-y-full items-center justify-center text-white lg:static lg:translate-y-0"
			>
				{nbspify(caseStudyCategoryNameMap[reference.caseStudyCategory][TENANT_LOCALE])}
			</div>
			<div class="border-gray h-[10rem] border bg-white p-6 md:h-[11.25rem]">
				<h3 class="text-primary group-hover:text-tertiary font-fustat mb-2 text-base font-extrabold md:text-[1.5rem]">
					{nbspify(reference.title[TENANT_LOCALE])}
				</h3>
				<div class="text-2xs line-clamp-3 text-gray-400">
					<Content content={reference.perex[TENANT_LOCALE]} contentClass={false} />
				</div>
			</div>
			<Link asButton variant="primary" class="w-[7.5rem] lg:hidden" href="/{getReferencePath(reference)}">
				{nbspify("Zjistit více")}
			</Link>
		</div>
	</div>
	<Link asButton variant="primary" class="hidden md:w-[13.75rem] lg:flex" href="/{getReferencePath(reference)}">
		{nbspify("Zjistit více")}
	</Link>
</a>
